import { __awaiter, __generator } from "tslib";
export var createCodeEditorDriver = function (wrapper) {
    var baseDriver = wrapper.$('.code-editor');
    var getCodeMirror = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, baseDriver.$('.CodeMirror').getNative()];
            case 1: return [2 /*return*/, (_a.sent()).CodeMirror];
        }
    }); }); };
    return {
        getValue: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCodeMirror()];
                case 1: return [2 /*return*/, (_a.sent()).getValue()];
            }
        }); }); },
        enterValue: function (value) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getCodeMirror()];
                case 1: return [2 /*return*/, (_a.sent()).setValue(value)];
            }
        }); }); },
        hasPlaceholder: baseDriver.$('pre.CodeMirror-placeholder').exists,
        getPlaceholder: baseDriver.$('pre.CodeMirror-placeholder').text,
    };
};
//# sourceMappingURL=driver.js.map